export const palette = {
  alternate: {
    main: '#F9F6FF',
    light: '#F9F8F8',
    dark: '#E5EAF4',
  },
  cardShadow: 'rgba(23, 70, 161, .11)',
  type: 'light',
  primary: {
    main: '#382720',
    contrastText: '#FFFFFF',
    light: '#E5E5E5',
  },
  secondary: {
    main: '#222',
    contrastText: '#002855',
    light: '#F1E3E0',
  },
  text: {
    primary: '#382720',
    light: '#222',
    secondary: '#382720',
    default: '#141B22',
    disabled: '#CCC',
    highlight: '#FFF',
    success: '#1CA179',
    border: '#E5EAF4',
  },
  divider: 'rgba(0, 0, 0, 0.12)',
  background: {
    main: '#FBF8F4',
    primary: '#382720',
    paper: '#FFF',
    default: '#FFF',
    header: '#FBF8F4',
    footer: '#FBF8F4',
    level2: '#f7f8fb',
    level1: '#FFF',
    tableHead: '#382720',
    tableSubhead: '#F7F7F7',
    arrow: '#10B7F2',
    tableAlternate: '#F8F8F8',
    alternate: '#E5E5E5',
    success: '#DBEFDC',
    error: '#FFEAEA',
    secondary: '#E5F4F9',
    light: '#F3E4E1',
  },
  verticalBar: {
    used: '#382720',
    unused: '#F9F3F2',
    unlimited: '#C0C0C0',
  },
};
